var _circle, _g, _circle2, _g2, _circle3, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 46,
    viewBox: "0 0 114 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 23,
    r: 22,
    fill: "#E5B4F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5553_66644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.641 23.0919C101.641 24.1899 100.751 25.0802 99.6529 25.0802C98.1064 25.0802 97.3509 24.3335 96.7809 23.9756C95.8907 23.4189 94.8965 22.1265 92.3361 22.9461C92.3427 22.9616 92.3471 22.9792 92.3516 22.9969C93.3214 22.8622 95.8001 22.9549 98.482 26.5294C99.4187 27.7798 99.5711 29.1892 98.7935 29.9668C98.0181 30.7423 96.7589 30.7423 95.9812 29.9668C94.8877 28.8733 94.8833 27.8107 94.7308 27.1546C94.4945 26.1317 94.7043 24.5146 92.3162 23.2841C92.3096 23.2996 92.3008 23.315 92.2919 23.3305C93.0718 23.9203 94.7618 25.7385 94.1299 30.1635C93.909 31.7099 93.0187 32.8144 91.9208 32.8144C90.8228 32.8144 89.9325 31.9242 89.9325 30.8262C89.9325 29.2798 90.6792 28.5243 91.0371 27.9543C91.5938 27.064 92.8862 26.0699 92.0666 23.5094C92.0511 23.5161 92.0334 23.5205 92.0158 23.5249C92.1505 24.4947 92.0577 26.9734 88.4833 29.6553C87.2329 30.592 85.8235 30.7445 85.0459 29.9668C84.2704 29.1914 84.2704 27.9322 85.0459 27.1546C86.1394 26.061 87.202 26.0566 87.8581 25.9042C88.881 25.6678 90.4981 25.8777 91.7286 23.4896C91.7131 23.4829 91.6977 23.4741 91.6822 23.4653C91.0923 24.2451 89.2742 25.9351 84.8492 25.3033C83.3028 25.0824 82.1982 24.1921 82.1982 23.0941C82.1982 21.9962 83.0885 21.1059 84.1865 21.1059C85.7329 21.1059 86.4884 21.8526 87.0584 22.2105C87.9487 22.7672 88.9428 24.0595 91.5032 23.2399C91.4966 23.2245 91.4922 23.2068 91.4878 23.1891C90.518 23.3239 88.0393 23.2311 85.3573 19.6567C84.4207 18.4063 84.2682 16.9968 85.0459 16.2192C85.8235 15.4416 87.0805 15.4438 87.8581 16.2192C88.9517 17.3127 88.9561 18.3753 89.1085 19.0315C89.3449 20.0543 89.135 21.6714 91.5231 22.9019C91.5298 22.8865 91.5386 22.871 91.5474 22.8555C90.7676 22.2657 89.0776 20.4475 89.7094 16.0226C89.9303 14.4762 90.8206 13.3716 91.9186 13.3716C93.0165 13.3716 93.9068 14.2619 93.9068 15.3598C93.9068 16.9062 93.1601 17.6618 92.8022 18.2317C92.2455 19.122 90.9532 20.1162 91.7728 22.6766C91.7882 22.67 91.8059 22.6655 91.8236 22.6611C91.6888 21.6913 91.7816 19.2126 95.356 16.5307C96.6064 15.594 98.0159 15.4416 98.7935 16.2192C99.5711 16.9968 99.5689 18.2538 98.7935 19.0315C97.7 20.125 96.6373 20.1294 95.9812 20.2819C94.9584 20.5182 93.3413 20.3084 92.1108 22.6965C92.1262 22.7031 92.1417 22.7119 92.1572 22.7208C92.747 21.9409 94.5652 20.2509 98.9901 20.8827C100.537 21.1037 101.641 21.994 101.641 23.0919Z",
    fill: "#62246B"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 23,
    r: 22,
    fill: "#6D247A"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5553_66644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.9707 23.9142C56.9707 18.5459 61.3228 14.1938 66.691 14.1938C66.691 19.5621 62.339 23.9142 56.9707 23.9142ZM56.9707 23.9142C56.9707 18.5459 52.6186 14.1938 47.2504 14.1938C47.2504 19.5621 51.6024 23.9142 56.9707 23.9142ZM47.2504 23.9142C47.2504 29.2824 51.6024 33.6345 56.9707 33.6345C56.9707 28.2662 52.6186 23.9142 47.2504 23.9142ZM56.9707 33.6345C62.339 33.6345 66.691 29.2824 66.691 23.9142C61.3228 23.9142 56.9707 28.2662 56.9707 33.6345Z",
    fill: "#3F0C46"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 23,
    r: 22,
    fill: "#D687EB"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_5553_66644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0889 14C24.3993 14.9266 22.9982 16.3359 22.0593 18.052C21.1941 16.3727 19.8973 14.9675 18.3161 14C15.1539 15.7325 13 19.1648 13 23.1166C13 27.0684 14.9718 30.202 17.9111 32C19.6007 31.0734 21.0018 29.6641 21.9407 27.948C22.8059 29.6273 24.1027 31.0325 25.6839 32C28.8461 30.2675 31 26.8352 31 22.8834C31 18.9316 29.0282 15.798 26.0889 14Z",
    fill: "#62246B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5553_66644"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.4407,
    height: 19.4407,
    fill: "white",
    transform: "translate(82.2004 13.3716)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5553_66644"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.4407,
    height: 19.4407,
    fill: "white",
    transform: "translate(47.2504 14.1938)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_5553_66644"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(13 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.ef2a86e6a0b9b7358321ddfea0439168.svg";
export { ForwardRef as ReactComponent };